import React from 'react';
import {useSelector} from "react-redux";
import {Link} from "react-router-dom";
import {
    ListPage,
    filterConstants,
    accessConstants,
    LoadChallengeResourcesAction
} from "mindsets-js-sdk";

import Table from "./Table";

export const CHALLENGE_RESOURCE_TITLES = [
    'Pre-Teaching Slides',
    'ELA/ELD Extension',
    'Project Extension',
    'Family Flyer'
];

export default function () {
    const selected_challenge_resource_ids = useSelector(state => state.selected_challenge_resource_ids);

    function bulkUpdate() {
        if (selected_challenge_resource_ids.length) {
            return (
                <Link to='/challenge_resources/update' className='button'>Bulk Update selected</Link>
            );
        }

        return null;
    }

    return (
        <>
            <h1>Challenge Resources</h1>
            <ListPage
                action={LoadChallengeResourcesAction}
                filter_columns={[
                    {
                        key: 'challenge_code',
                        name: 'Challenge Code',
                        expressions: [filterConstants.EXPRESSION_EQUAL, filterConstants.EXPRESSION_NOT_EQUAL, filterConstants.EXPRESSION_CONTAINS, filterConstants.EXPRESSION_NOT_CONTAINS]
                    },
                    {
                        key: 'title',
                        name: 'Title',
                        expressions: [filterConstants.EXPRESSION_EQUAL],
                        values: CHALLENGE_RESOURCE_TITLES.map(title => ({label: title, value: title}))
                    },
                    {
                        key: 'name',
                        name: 'Name',
                        expressions: [filterConstants.EXPRESSION_EQUAL, filterConstants.EXPRESSION_NOT_EQUAL, filterConstants.EXPRESSION_CONTAINS, filterConstants.EXPRESSION_NOT_CONTAINS]
                    }
                ]}
                sort_columns={[
                    {
                        key: 'id',
                        name: 'ID'
                    },
                    {
                        key: 'challenge_code',
                        name: 'Challenge Code'
                    },
                    {
                        key: 'name',
                        name: 'Name'
                    }
                ]}
                default_order_by='challenge_code'
                entity={'challenge_resources'}
                create_button={(
                    <div className="d-flex justify-content-end flex-gap-5">
                        <Link to="/challenge_resources/new" className="button">Add Resource</Link>
                        {bulkUpdate()}
                    </div>
                )}
                permissions={[accessConstants.PERMISSION_CAN_SEE_CHALLENGES]}
            >
                <Table/>
            </ListPage>
        </>
    );
}
